import Model from 'src/storage/list';
import moment from 'moment';
import config from 'src/config';

const apiHost = config.apiHost();
const apiPath = apiHost + '/api/0/json';

class AdminInvoiceModel extends Model {
  id = 'AdminInvoiceModel';
  persistent = false;
  refreshOnInit = false;
  refreshOnSubscribe = true;
  sortBy = null;
  defaultState = () => ({
    current: 'recent',
    pageIndex: 0,
    startDate: moment().startOf('isoWeek'),
    endDate: moment().endOf('isoWeek'),
    status: 'paid',
    sortBy: {
      sortKey: 'invoiceDate',
      desc: true
    }
  });
  apiConfig = {
    refresh: {
      url: 'admin/invoice/refresh',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'invoice_list'
    },
    list: {
      url: 'admin/invoice/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'invoice_list'
    },
    search: {
      url: 'admin/invoice/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'invoice_list'
    },
    pdfLink: {
      url: 'invoice/pdfLink',
      validation: {
        id: 'baseId'
      }
    },
    detail: {
      url: 'admin/invoice/detail',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },
    refund: {
      url: 'admin/invoice/refund',
      validation: {
        id: 'baseId'
      },
      cancellable: true,
      event: 'invoice_refund'
    },
    clinic: {
      url: 'account/detail',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile',
    'foxsocket:message:invoice': 'handleInvoiceWS',
    invoice: 'handleInvoice'
  };

  handleProfile = (profile) => {
    this.user = profile;
    this.setState({ user: profile });
  };

  handleInvoiceWS = ({ data }) => {
    this.log('handleInvoiceWS', data);
    this.handleInvoice(data);
  };

  handleInvoice = (invoice) => {
    this.log('handleInvoice', invoice);
    this.addItem(invoice);
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy,
      status: this.state.status === 'all' ? null : this.state.status
    };
    let startDate = this.input('startDate');
    if (startDate) {
      req.startDate = Number(startDate.format('YYYYMMDD'));
    }
    let endDate = this.input('endDate');
    if (endDate) {
      req.endDate = Number(endDate.format('YYYYMMDD'));
    }
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  refund = (data, cb) => {
    let req = {
      id: data.id
    };
    this.api('refund', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.setListState({
          items: this.items().map((item) => (data.id === item.id ? { ...item, ...data } : item))
        });
        this.refresh();
      }
    });
  };

  // The PDF needs a login. Ask the server for a short-lived link, then open it.
  // The tab is opened inside the click so popup blockers allow it.
  openPdf = (item) => {
    const w = window.open('', '_blank');
    if (w) w.opener = null;
    this.api('pdfLink', { id: item.id }, (err, data, success) => {
      if (success && data?.ok && data.token) {
        const url =
          apiPath + '/invoice/pdf?id=' + encodeURIComponent(item.id) + '&dl=' + encodeURIComponent(data.token);
        if (w) w.location.href = url;
        else window.location.href = url;
      } else if (w) {
        w.close();
      }
    });
  };

  loadDetail = (id, cb) => {
    let req = {
      id
    };
    this.api('detail', req, (err, data, success) => {
      cb && cb(err, data, success);
    });
  };
}

const model = new AdminInvoiceModel();
export default model;
